module.exports = "<div [innerHtml]=\"text | safeHtml\"></div>\n"